import React from 'react';
import { Redirect, Route } from '../router-compat';
import { inject } from 'mobx-react';

import routeWatcher from '../app/route-watcher';
import TopNav from './top-nav';

const ConditionalRoute = ({ component, condition, redirect, nav = false, ...rest }) => {
  const Component = routeWatcher(component);

  // Change this to CompatRoute and it 💣
  return <Route {...rest} render={props => {
    if (condition || condition === undefined) {
      if (nav) {
        return (
          <div>
            <TopNav />
            <Component {...props} />
          </div>
        );
      }

      return <Component {...props} />;
    }

    rest.uiStore.updateReferrer(props.location.pathname);

    return <Redirect to={redirect} />;
  }} />;
};

export default inject('uiStore')(ConditionalRoute);
